
<template>
  <div>
    <template v-if="!wapShow">
    <header1 :menuIndex="4"></header1>
    <div class="news-detail-box">
      <h1 class="app-content news-detail-title  p1" :style="{'background-image':'url('+obj.cover+')'}">
        <div class="meng"></div>
        <div class="app-content" >
          <p class="p2">{{obj.name}}</p>
          <p style="line-height: 2;letter-spacing: 2px">{{obj.digest}}</p>
        </div>
      </h1>
      <div class="app-content" style="margin-top: 20px" v-html="obj.content">
      </div>
    </div>
    <footers></footers>
    </template>
    <template v-else>
      <wap-index></wap-index>
    </template>
  </div>
</template>


<script type="text/javascript">

  import header1 from "@/components/header1"
  import footers from "@/components/footers"
  import axios from "axios";
  import page from "@/components/page"
  import eventBus from "../../assets/js/eventBus";
  import wapIndex from "../case/wapDetail";
  export default {
    name: 'news',
    components:{header1,footers,page,wapIndex},
    data(){
      return{
        id:"",
        obj:{},
        list1:[],
        wapShow:false
      }
    },
    mounted() {
      eventBus.$on("wapShow",(data)=> {
        this.wapShow = data;
        if(!this.wapShow) {
          this.id = this.$route.query.id;
          this.getcaseDetail()
        }
      })

    },
    methods:{
      getcaseDetail(){
        axios.get(this.pageUrl+`/project-case/${this.id}`).then(res=>{
          this.obj=res.data.data;
        })
      },
    }

  }
</script>

<style scoped>
  .p2{
    font-size: 32px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    margin-top: 120px;
    margin-bottom: 40px ;
    letter-spacing: 2px;
  }
  .p1{
    font-size: 18px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
  }
  .news-detail-box{
    min-height: 500px;
    margin-top: 80px;
  }
  .news-detail-title{
    width: 100%;
    height: 560px;
    background-size: cover;
    position: relative;
  }
  .meng{
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(13, 13, 43, 1);
    opacity: 0.56;
  }
  .news-detail-time{
    font-size: 24px;
    text-align: right;
    margin: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/case/detail.vue